import { Button, Box, IconButton, Tooltip } from "@mui/material";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState } from "react";
import { campaignStatusEnum } from "app/pages/CampaignPage/data/type";

interface CellButtonWithIconProps {
  params: any;
  onClick: (params: any, clickedElement: "email" | "pause" | "delete" | "text") => void;
  children: React.ReactNode;
}

const CellButtonWithActionIcons = ({ params, onClick, children }: CellButtonWithIconProps) => {
  const [isHovered, setIsHovered] = useState(false);

  // Determine tooltip text for the Email Icon
  const emailTooltip =
    !params.row?.no_of_leads || params.row?.status === campaignStatusEnum.archived
      ? "No leads available to enable send email action"
      : "Send Email";

  // Determine tooltip text for the Pause Icon based on campaign status
  let pauseTooltip = "";
  if (params.row?.status === campaignStatusEnum.underNurturing) {
    pauseTooltip = "Pause Campaign";
  } else if (params.row?.status === campaignStatusEnum.paused) {
    pauseTooltip = "Resume Campaign";
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        gap: 1,
        // On hover, elements with class "action-icon" become visible.
        "&:hover .action-icon": { visibility: "visible" },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Button
        variant="text"
        size="small"
        tabIndex={params.hasFocus ? 0 : -1}
        sx={{
          color: "black",
          textDecoration: "underline",
          textTransform: "none",
          fontSize: "14px",
          padding: 0,
          minWidth: 0,
        }}
        onClick={() => onClick(params, "text")}
      >
        {children}
      </Button>

      <Tooltip title={emailTooltip}>
        <IconButton
          size="small"
          className="action-icon"
          sx={{ visibility: "hidden", padding: 0 }}
          onClick={() => onClick(params, "email")}
        >
          <MarkEmailReadIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title={pauseTooltip}>
        <IconButton
          size="small"
          className="action-icon"
          sx={{
            visibility: "hidden",
            padding: 0,
            // Only show the pause/play icon if the status is under nurturing or paused
            display:
              params.row?.status === campaignStatusEnum.underNurturing|| params.row?.status === campaignStatusEnum.paused
                ? ""
                : "none",
          }}
          onClick={() => onClick(params, "pause")}
        >
          {params.row?.status === campaignStatusEnum.underNurturing ? (
            <PauseIcon fontSize="small" />
          ) : (
            <PlayArrowIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete Campaign">
        <IconButton
          size="small"
          className="action-icon"
          sx={{ visibility: "hidden", padding: 0 }}
          onClick={() => onClick(params, "delete")}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CellButtonWithActionIcons;
